<template>
  <form enctype="multipart/form-data">
    <b-loading v-model="isLoading" :is-full-page="true"></b-loading>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Copy Questions</p>
      </header>
      <div style="height:400px;" class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12">
            <b-field label="Select Grade Subjects" expanded>
                <b-select expanded v-model="questions_copy.grade_subject" @input="loadCategoriesOfGradeSubject()">
                  <option v-for="grade_subject in fetchGradeSubjects" :key="grade_subject._id" :value="grade_subject._id">
                    {{grade_subject.subject.name}} - {{grade_subject.grade.name}}
                  </option>
                </b-select>
            </b-field>
            
            <p class="title is-6 mb-2">Select Category</p>
            <treeselect
              ref="treeselect_copy"
              :multiple="false"
              :options="categories"
              :normalizer="$common.normalizer"
              :defaultExpandLevel="0"
              value-consists-of="ALL"
              placeholder="Select Category"
              v-model="questions_copy.category"
              :append-to-body="false"
              search-nested
              :z-index="1"
              @input="loadSkillsOfCategory()"
            />

            <b-field label="Select Skills" expanded>
                <b-select expanded v-model="questions_copy.to_skill" >
                  <option v-for="skill in skills" :key="skill._id" :value="skill._id">{{skill.name}}</option>
                </b-select>
            </b-field>

          </div>
          <div class="column is-12">
            <b-button @click="copyThisQuestions()" type="is-primary">Copy</b-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name : 'copy-skill-questions',
  props : {
    questions : {
      type : Array,
      required : true
    }
  },
  data(){
    return {
      isLoading : false,
      categories : [],
      skills : [],
      questions_copy : {
        grade_subject : null,
        category : null,
        to_skill : null
      }
    }
  },
  computed : {
    ...mapGetters(['getTeacherToken', 'fetchGradeSubjects'])
  },
  methods : {
    ...mapActions(['loadGradeSubjects', 'loadCategories', 'loadSkills', 'copyQuestions']),
    loadCategoriesOfGradeSubject(){
      this.isLoading = true
      this.loadCategories({
        token : this.getTeacherToken,
        filter : {
          grade_subject : this.questions_copy.grade_subject,
          tree : true
        },
        do_commit : false
      }).then(res => {
        this.isLoading = false
        this.categories = res.data
      })
    },
    loadSkillsOfCategory(){
      this.isLoading = true
      this.loadSkills({
        token : this.getTeacherToken,
        filter : {
          category : this.questions_copy.category
        },
        do_commit : false
      }).then(res => {
        this.isLoading = false
        this.skills = res.data
      })
    },
    copyThisQuestions(){
      this.isLoading = true
      let copy = Object.assign({}, this.questions_copy)
      copy['questions'] = this.questions
      delete copy.grade_subject
      this.copyQuestions({
        copy,
        token : this.getTeacherToken
      }).then(() => {
        this.isLoading = false
        this.$emit('close')
        this.$buefy.toast.open({
          message: 'Questions successfully copied',
          type: 'is-success'
        })
      }).catch(err => {
        this.isLoading = false
        this.$buefy.toast.open({
          message: err.response.data,
          type: 'is-danger'
        })
      })
    },
  },
  created(){
    this.loadGradeSubjects({ 
      token : this.getTeacherToken, 
    })
  }
}
</script>